import useHistoryRequestGate from './useHistoryRequestGate';
import PanelSkeleton from '../../utils/PanelSkeleton';
import PopupCloseButton from '../../utils/PopupCloseButton';
import PlatformModalLayer from '../../utils/PlatformModalLayer';
import React, { useEffect, useState, useMemo } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import APIMiddleware from '../../../data/api/Api-Middleware.js';
import {
  API_ENDPOINT_All_CLOSED_POSITIONS,
  API_ENDPOINT_GET_ALL_CLOSED_POSITIONS_AND_SAVE,
} from '../../../data/Endpoints-API';
import { useAuthContext } from '../../../contexts/Auth-Context';
import { useChartContext } from '../../../contexts/Chart-Context.js';
import {
  adjustDateTime,
  formatDate,
  formatFilterDate,
  formatFilterDateOrPlaceholder,
  formatDigitBasePrice,
  formatFixedTrimmed,
} from '../../../utils/format.js';
import './Positions.css';
import { InfoHexIcon } from './TableActionIcons.jsx';
import { FaRobot, FaTimes } from 'react-icons/fa';
import { useAccountManagerContext } from '../../../contexts/Account-Manager-Context.js';
import { useMetricsContext } from '../../../contexts/Metrics-Context.js';
import Select from "../../utils/Select.jsx";
import { useSymbolContext } from '../../../contexts/Symbol-Context.js';
import { toast } from 'react-toastify';
import { API_ENDPOINT_GET_POSITION_DETAILS } from '../../../data/Endpoints-API.js';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import PositionEvent from './PositionEvent.jsx';
import AppDatePicker, { TABLE_PERIOD_MIN_YEAR, parseLocalDate, anchorRectFromEvent } from '../../common/AppDatePicker.jsx';
import './Account-Manager.scss';
import { dropdownOptionStyle } from '../../../utils/dropdownOptionStyles.js';
import useTableHScrollPin from './useTableHScrollPin.js';
import { CgSpinner } from "react-icons/cg";
import {DebounceInput} from 'react-debounce-input';
import { useTranslation } from 'react-i18next';
import { translateDirection } from '../../../i18n/directionLabel.js';
import NoRecordsMessage from '../../utils/NoRecordsMessage.jsx';
import { getPeriodOptions, findPeriodOption } from '../../../i18n/periodOptions.js';

const PositionHistory = ({ name, handleRowClick , renderRows = true }) => {
  const { t } = useTranslation();
  
  const positonHistoryDivRef = React.useRef(null);
  useTableHScrollPin(positonHistoryDivRef);
  const { user, platFromData } = useAuthContext();
  const [mobileMode, setMobileMode] = useState(false);
  const { setClickedPosition, symbolData } = useSymbolContext();
  const { utcOffset, setShowDealsModal, showDealsModal, userCurrencyExchangeRate } = useMetricsContext();
  const { selectedStyle, setSelectedStyle, styleOptions,} = useChartContext();
  const [radioChecked, setRadioChecked] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [selectDisabled2, setSelectDisabled2] = useState(false);
  const [selectDisabled, setSelectDisabled] = useState(false);
  const [symbolOrId, setSymbolOrId] = useState('');
  const [radioChecked2, setRadioChecked2] = useState(true);
  const [filter, setFilter] = useState('');
  const [botFilter, setBotFilter] = useState('all');
  const [selectedOrderDate, setselectedOrderDate] = useState('all');
  const [search, setSearch] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [activeDateField, setActiveDateField] = useState('start');
  const [pickerAnchorRect, setPickerAnchorRect] = useState(null);


  
  const [expandedRows, setExpandedRows] = useState({});
 
  const monthNames = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 960) {
        setMobileMode(true);
        setPageSize(50);
      } else {
        setMobileMode(false);
        setPageSize(50); 
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const {
    setPositionHistoryCount,
    isClosingAllPositions,
    closedPositions,
    setClosedPositions,
    setClosedPositionLength,
    positionHistoryCount,
    setClosedPositionsAll,
    setBotPositionHistoryCount,
  } = useAccountManagerContext();

  const [isCustomRangeSelected, setIsCustomRangeSelected] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [orderDate, setOrderDate] = useState({
    startDate: '2000-01-01 00:00:00',
    endDate: getTodaysEnd(),
  });
  const [datePickar, setDatePickar] = useState({
    startDate: '2000-01-01 00:00:00',
    endDate: getTodaysEnd(),
  });
  const [positionDealsInfo, setPositionDealsInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const bottomRef = React.useRef(null);
  const enableInfiniteScroll = true;


  createTheme(
    'solarized',
    {
      text: {
        primary: 'var(--content-secondary, #b8bcc8)', // normalTextColor
      },
      background: {
        default: 'var(--surface-panel, #252b42)', // firstBox
      },
      context: {
        background: 'var(--surface-panel, #252b42)', // firstBox
        text: 'var(--content-secondary, #b8bcc8)', // normalTextColor
      },
    },
    'dark',
  );
  function getTodaysEnd() {
    const today = new Date();

    // Set the time to the end of the day (23:59:59)
    today.setHours(23, 59, 59, 999); // Hours, minutes, seconds, milliseconds

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Month (0-indexed) with leading zero
    const day = String(today.getDate()).padStart(2, '0');
    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const seconds = String(today.getSeconds()).padStart(2, '0');

    // Format the date and time in the desired format
    const formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedTimestamp;
  }

  function convertDatetime(datetimeString) {
    // Parse the date string using a date object
    const date = new Date(datetimeString);

    // Get year, month (0-indexed), day, hours, minutes, and seconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero for single-digit months
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Format the date in the desired format
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }

  const handlePositionModal = async () => {
    const response = await APIMiddleware.get(
      API_ENDPOINT_GET_POSITION_DETAILS(
        user.userId,
        selectedPosition?.position_id,
      ),
    );
    console.log("POSITION HISTORY POSITION HISTORY :: " , response);
    
    setPositionDealsInfo(response.resp);
    setShowDealsModal(true);
  };
  const handleRowTheClick = (row) => {
    const clickedData = {
      id: row.position_id,
      symbol: row.symbol,
      openedAt: row.position_opened_at,
      direction: row.direction,
      closedAt: row.created_at,
    };

    console.log('Clicked Position Data:', clickedData);

    setClickedPosition(clickedData);
  };

  const mergeUniqueByKey = (baseArray, incomingArray, key) => {
   const map = new Map();
    for (const item of baseArray) {
      if (item && item[key] !== undefined && item[key] !== null) {
        map.set(item[key], item);
      }
    }
    for (const item of incomingArray) {
      if (item && item[key] !== undefined && item[key] !== null) {
        map.set(item[key], item);
      }
    }
    return Array.from(map.values());
  };

  const requestKey = JSON.stringify([user?.userId, pageSize, search, filter, orderDate, datePickar, isCustomRangeSelected, botFilter]);
  const requests = useHistoryRequestGate(requestKey, platFromData[3]?.closedPositions);
  const fetchPage = async (page = 1, append = false) => {
    if (!(Number(user?.userId) > 0)) return;

    var startDate = convertDatetime(orderDate.startDate);
    var endDate = convertDatetime(orderDate.endDate);
    
    if (isCustomRangeSelected) {
      if (!datePickar.startDate || !datePickar.endDate) { setIsLoading(false); setIsFetchingMore(false); return; }
      startDate = convertDatetime(datePickar.startDate);
      endDate = convertDatetime(datePickar.endDate);
    }
    const request = requests.begin(page, append);
    if (!request) return;
    let applied = false;
    try {
      if (append) {
        setIsFetchingMore(true);
      } else {
        setIsLoading(true);
      }
      const response = await APIMiddleware.get(
        API_ENDPOINT_All_CLOSED_POSITIONS(
          user.userId,
          page,
          pageSize,
          search,
          startDate,
          endDate,
          botFilter,
        ),
      );

      if (!requests.current(request)) return;
      const respData = (response.data || []).filter(Boolean);

      if (append) {
        setData(prev => mergeUniqueByKey(prev, respData, 'position_id'));
        setClosedPositions(prev => mergeUniqueByKey(prev || [], respData, 'position_id'));
      } else {
        setData(respData);
        setClosedPositions(respData);
      }

      setTotal(response.total || 0);
      setClosedPositionLength(response.total || 0);
      setPositionHistoryCount(response.total || 0);

      const maxPage = Math.ceil((response.total || 0) / pageSize) || 1;
      setCurrentPage(page);
      setHasMore(page < maxPage);
      applied = true;
    } catch (error) {
      if (requests.current(request)) console.error(error);
    } finally {
      if (!requests.finish(request, applied)) return;
      if (append) setIsFetchingMore(false);
      else setIsLoading(false);
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (!isClosingAllPositions) {
        setCurrentPage(1);
        fetchPage(1, false);
      }
    }, 0);

    return () => clearTimeout(debounceTimer);
  }, [
    // currentPage,
    user?.userId,
    pageSize,
    filter,
    search,
    orderDate,
    datePickar,
    isCustomRangeSelected,
    platFromData[3]?.closedPositions,
    botFilter,
  ]);

  const loadMore = () => {
    const maxPage = Math.ceil((total || 0) / pageSize) || 1;
    if (isFetchingMore || isLoading) return;
    if (currentPage >= maxPage) return;
    const nextPage = currentPage + 1;
    fetchPage(nextPage, true);
  };

  useEffect(() => {
    if (!enableInfiniteScroll) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      },
      { root: null, rootMargin: '200px', threshold: 0.1 },
    );

    const el = bottomRef.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
      observer.disconnect();
    };
    
  }, [bottomRef, isFetchingMore, isLoading, currentPage, total, pageSize]);

  // Desktop: column header is sticky inside DataTable's own scroller, so load-more
  // must watch that scroller (the sentinel sits outside it).
  useEffect(() => {
    if (!enableInfiniteScroll || mobileMode) return;
    const scroller = positonHistoryDivRef.current;
    if (!scroller) return;

    const onScroll = () => {
      if (isFetchingMore || isLoading) return;
      if (scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 200) {
        loadMore();
      }
    };

    scroller.addEventListener('scroll', onScroll);
    return () => scroller.removeEventListener('scroll', onScroll);
  }, [mobileMode, isFetchingMore, isLoading, currentPage, total, pageSize, data.length]);

  useEffect(() => {

  } , [expandedRows]);

  const MobilePositionHistoryRow = ({ position, isExpanded, onToggle, name }) => {
    return (
      <div className={`mobile-position-row ${isExpanded ? 'expanded' : ''} ${Number(position.is_bot_trade) === 1 ? 'bot-position' : ''}`}>
        <div onClick={onToggle}>
          <div className="main-row">
            <div className="left-section">
              <div className="symbol-direction">
                {Number(position.is_bot_trade) === 1 && (
                  <FaRobot className="bot-icon" style={{ color: 'var(--content-secondary, #b8bcc8)', fontSize: '14px' }} />
                )}
                {Number(position.is_bot_trade) === 2 && (
                  <span className="ea-type-badge" data-tooltip={t('actions.expertAdvisor')}>EA</span>
                )}
                <span className="symbol-name">{position.symbol}</span>
                <span
                  style={{
                    color:
                      position.direction?.toLowerCase() === 'buy'
                        ? selectedStyle.buyColor
                        : selectedStyle.sellColor
                  }}
                >
                  {translateDirection(position.direction, t)}
                </span>
                <span className="quantity">{formatFixedTrimmed(Number(position.quantity), 8)}</span>
              </div>
              <div className="price-movement">
                {position.entry_price && !isNaN(parseFloat(position.entry_price)) ? formatFixedTrimmed(position.entry_price, 8) : '---'} → {position.exit_price && !isNaN(parseFloat(position.exit_price)) ? formatFixedTrimmed(position.exit_price, 8) : '---'}
              </div>
            </div>
            <div
              style={{
                color:
                  position.realized_pnl >= 0
                    ? selectedStyle.buyColor
                    : selectedStyle.sellColor
              }}
            >
              {!isNaN(Number(position.realized_pnl))
                ? formatFixedTrimmed(Number(position.realized_pnl), 2)
                : '---'}
            </div>
          </div>
          
          {isExpanded && (
            <div className="expanded-section">
              <div className="row">
                <div className="half-row">
                  <span className="label-open-time">{formatDate(adjustDateTime(position.position_opened_at, utcOffset))}</span>
                </div>
                <div className="half-row">
                  <span className="label-close-time">{formatDate(adjustDateTime(position.closed_at, utcOffset))}</span>
                </div>
              </div>
            
              <div className="row">
                <div className="half-row">
                  <span className="label">Margin:</span>
                  <span className="value">{formatFixedTrimmed((position.margin * userCurrencyExchangeRate), 4)}</span>
                </div>
                <div className="half-row">
                  <span className="label">ID:</span>
                  <span className="value">{`PID${position.position_id.toString().padStart(8, "0")}`}</span>
                </div>
              </div>
            </div>          
          )}
        </div>
      </div>
    );
  };

  const MobilePositionHistoryList = ({ positions, name }) => {
    
    const toggleRow = (id) => {
      setExpandedRows(prev => ({
        ...prev,
        [id]: !prev[id]
      }));
    };    
  
    return (
      <div className="mobile-positions-container">
        {positions.map(position => (
          <MobilePositionHistoryRow
          name={name}
            key={`position-${position.id}`}
            position={position}
            isExpanded={expandedRows[position.id]}
            onToggle={() => toggleRow(position.id)}
          />
        ))}
      </div>
    );
  };

  const positionDetails = (e) => {
    setSelectedPosition(e);
    console.log(e, 'selectedPosition');
    setIsEdit(true);
  };
  const fetchAndSaveAllClosedPositions = async () => {
    try {
      const response = await APIMiddleware.get(
        API_ENDPOINT_GET_ALL_CLOSED_POSITIONS_AND_SAVE(user.userId),
      );

      if (response.data) {
        const sortedPositions = response.data.sort(
          (a, b) =>
            new Date(b.position_closed_at) - new Date(a.position_closed_at),
        );

        setClosedPositionsAll(sortedPositions);
      } else {
        console.warn('No closed positions found.');
      }
    } catch (error) {
      console.error('Error fetching all closed positions:', error);
      toast.error('Failed to fetch closed positions. Please try again.', {
        position: 'top-right',
      });
    }
  };

  // useEffect(() => {
  //   if(user?.userId){

  //     fetchAndSaveAllClosedPositions()
  //   }
  // }, [user?.userId, positionHistoryCount]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (value) => {
    setFilter(value);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value); // Update search state
    setIsLoading(true)
  };
  const formatPositionHistoryId = (orderId) => {
    return orderId ? `PID${orderId.toString().padStart(8, '0')}` : '---';
  };

  const columns = useMemo(() => [
    {
      name: '',
      cell: (row) => (
        row._endOfList ? (
          <div className="no-more-inline">{t('tables.noMorePositions')}</div>
        ) : (
        <div className="positions-button">
          <button
            type="button"
            type="button" aria-label={t('editSltp.positionTitle')}
            className="modal-icon"
            onClick={() => positionDetails(row)}
          >
            <InfoHexIcon />
          </button>
          {Number(row.is_bot_trade) === 1 ? (
            <FaRobot style={{ height: '1rem', width: '1rem' }} />
          ) : (
            ''
          )}
          {Number(row.is_bot_trade) === 2 && (
            <span className="ea-type-badge" data-tooltip={t('actions.expertAdvisor')}>EA</span>
          )}
        </div>
        )
      ),
      grow: 0,
      width: '90px',
      minWidth: '90px',
      maxWidth: '90px',
      ignoreRowClick: true,
      nonSortable: true,
    },

    {
      name: t('tables.id'),
      id: 'id',
      selector: (row) => formatPositionHistoryId(row.position_id),
      grow: 0,
      minWidth: '108px',
      wrap: false,
      cell: (row) => row._endOfList ? null : <span className="cell-id">{formatPositionHistoryId(row.position_id)}</span>,
    },
    {
      name: t('tables.openedAt'),
      selector: (row) =>
        row._endOfList ? '' : formatDate(adjustDateTime(row.position_opened_at, utcOffset)),
      minWidth: '124px',
      grow: 1,
      wrap: false,
    },
    {
      name: t('tables.closedAt'),
      selector: (row) => row._endOfList ? '' : formatDate(adjustDateTime(row.created_at, utcOffset)),
      minWidth: '124px',
      grow: 1,
      wrap: false,
    },
    {
      name: t('tables.symbol'),
      selector: (row) => row._endOfList ? '' : row.symbol,
      grow: 1,
      minWidth: '72px',
      wrap: false,
    },
    {
      name: t('tables.quantity'),
      selector: (row) => row._endOfList ? '' : formatFixedTrimmed(row.quantity, 8),
      minWidth: '56px',
      grow: 1,
      wrap: false,
    },
    {
      name: t('tables.direction'),
      selector: (row) => row._endOfList ? '' : row.direction,
      cell: (row) => (row._endOfList ? '' : translateDirection(row.direction, t)),
      grow: 1,
      minWidth: '72px',
      wrap: false,
    },
      {
          name: t('tables.margin'),
          selector: (row) => row._endOfList ? '' : formatFixedTrimmed((row.margin * userCurrencyExchangeRate), 4),
          grow: 1,
          minWidth: '52px',
          wrap: false,
        },
    {
      name: t('tables.entry'),
      selector: (row) => {
        if (row._endOfList) return '';
        const entryPrice = parseFloat(row.entry_price);
        return isNaN(entryPrice) ? "---" : formatFixedTrimmed(row.entry_price, 8);
      },
      grow: 1,
      minWidth: '52px',
      wrap: false,
    },
    {
      name: t('tables.exit'),
      selector: (row) => {
        if (row._endOfList) return '';
        const exitPrice = parseFloat(row.exit_price);
        return isNaN(exitPrice) ? "---" : formatFixedTrimmed(row.exit_price, 8);
      },
      grow: 1,
      minWidth: '52px',
      wrap: false,
    },
    {
      name: t('tables.pnl'),
      selector: (row) => {
        if (row._endOfList) return '';
        const pnlValue = (parseFloat(row.realized_pnl) * userCurrencyExchangeRate);
        if (isNaN(pnlValue)) return '---';
        return formatFixedTrimmed(pnlValue, 2);
      },
      grow: 1,
      minWidth: '52px',
      wrap: false,
      cell: (row) => {
        if (row._endOfList) return null;
        const pnlValue = (parseFloat(row.realized_pnl) * userCurrencyExchangeRate);
        if (isNaN(pnlValue)) return <span>---</span>;
        const color =
          pnlValue > 0
            ? selectedStyle.buyColor
            : pnlValue < 0
              ? selectedStyle.sellColor
              : 'var(--content-primary, #e8eaf0)';
        return <span style={{ color }}>{formatFixedTrimmed(pnlValue, 2)}</span>;
      },
    }
  ], [t, selectedStyle, userCurrencyExchangeRate, utcOffset]);

  const conditionalRowStyles = [
    {
      when: (row) => row._endOfList,
      style: {
        minHeight: '36px',
        height: '36px',
        cursor: 'default',
        backgroundColor: 'var(--surface-panel, #252b42)',
        borderBottomWidth: '0',
        '&:hover': { backgroundColor: 'var(--surface-panel, #252b42)' },
      },
    },
    {
      when: (row) => Number(row.is_bot_trade) === 1 && row.position_id !== selectedRowId,
      style: {
        backgroundColor: 'var(--surface-raised, #2f3549)',
        color: 'var(--content-primary, #e8eaf0)',
      },
    },
    {
      when: (row) => row.position_id != null && row.position_id === selectedRowId,
      classNames: ['am-row-selected'],
      style: {
        backgroundColor: '#323a54',
        color: 'var(--content-primary, #e8eaf0)',
        '&:hover': { backgroundColor: '#323a54' },
      },
    },
  ];

  const showEndRow = !mobileMode && !hasMore && !isFetchingMore && data.length > 0;

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '4px !important',
        paddingRight: '4px !important',
        justifyContent: 'flex-start !important',
        alignItems: 'center !important',
        textAlign: 'left !important',
      },
    },
    cells: {
      style: {
        paddingLeft: '4px !important',
        paddingRight: '4px !important',
        justifyContent: 'flex-start !important',
        alignItems: 'center !important',
        textAlign: 'left !important',
        // cursor: `${!mobileMode ? (isSymbolSelecting ? 'wait' : 'pointer') : ''}`,
      },
    },
    pagination: {
      style: {
        minHeight: '30px',
        height: '30px',
      },
    },
    headRow: {
      style: {
        minHeight: '10px',
        height: '30px',
        backgroundColor: 'var(--surface-panel, #252b42)',
      },
      denseStyle: {
        minHeight: '10px',
        height: '30px',
      },
    },
  };

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  const handleFirstDivClick = () => {
    setRadioChecked(true);
    setSelectDisabled(false); // Ensure select is enabled when clicking on the first div
  };
  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '24px',
      height: '24px',
      width: '140px',
      minWidth: '140px',
      maxWidth: '140px',
      margin: 0,
      borderColor: state.isFocused
        ? `${selectedStyle.buyColor} !important`
        : 'var(--surface-border, #3a4156) !important',
      backgroundColor: 'var(--surface-panel, #252b42) !important',
      borderRadius: '6px',
      boxShadow: 'none',
      cursor: 'pointer',
      alignItems: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: `${selectedStyle.buyColor} !important`,
        boxShadow: 'none',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      paddingLeft: '0',
      margin: '0',
      color: 'var(--content-secondary, #b8bcc8) !important',
      fontSize: '11px',
      lineHeight: '16px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 2px 0 6px',
      height: '22px',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '22px',
      alignSelf: 'center',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0 4px',
      color: state.isFocused || state.selectProps.menuIsOpen
        ? `${selectedStyle.buyColor} !important`
        : 'var(--content-secondary, #b8bcc8) !important',
      transition: 'color 0.15s ease',
      transform: 'none',
      '&:hover': {
        color: `${selectedStyle.buyColor} !important`,
      },
      svg: {
        width: '14px',
        height: '14px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        transformOrigin: 'center',
      },
    }),
    option: (provided, state) => dropdownOptionStyle(provided, state, {
      padding: '0 12px',
      height: '24px',
      minHeight: '24px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      fontSize: '11px',
      lineHeight: '1.35',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-panel, #252b42) !important',
      margin: '0.3rem 0 0 0 !important',
      zIndex: 9999,
      overflow: 'hidden',
      borderRadius: '6px',
      border: '1px solid var(--surface-border, #3a4156)',
      boxShadow: 'none',
      minWidth: '140px',
      width: '140px',
      maxWidth: '140px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '132px',
      minHeight: '3px',
      width: '100%',
      overflowY: 'auto',
      padding: '2px 0',
      scrollbarWidth: 'thin',
      scrollbarColor: 'rgba(170, 170, 170, 0.45) transparent',
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  const periodOptions = useMemo(() => getPeriodOptions(t), [t]);
  const [periodValue, setPeriodValue] = useState('all');
  const selectedOption = findPeriodOption(periodOptions, periodValue);
  const changehandlefunction = (option) => {
    if (!option) return;
    setPeriodValue(option.value);
    const value = option.value;

    if (value === 'custom') {
      setIsCustomRangeSelected(true);
      setRadioChecked2(false);
      setDatePickar({ startDate: null, endDate: null });
      return;
    }

    setIsCustomRangeSelected(false);
    setRadioChecked2(true);

    if (value === 'Today') {
      const today = new Date();

      const startDate = new Date(today);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(today);
      endDate.setHours(23, 59, 59, 999);

      const dateobj = { startDate, endDate };
      setOrderDate(dateobj);
    } else if (value === 'Yesterday') {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      const startDate = new Date(yesterday);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(yesterday);
      endDate.setHours(23, 59, 59, 999);

      const dateobj = { startDate, endDate };
      setOrderDate(dateobj);
    } else if (value === 'CurrentWeek') {
      const today = new Date();
      const startOfWeek = new Date(
        today.setDate(today.getDate() - today.getDay()),
      );
      const endOfWeek = new Date(
        today.setDate(today.getDate() - today.getDay() + 6),
      );

      startOfWeek.setHours(0, 0, 0, 0);
      endOfWeek.setHours(23, 59, 59, 999);

      const dateobj = { startDate: startOfWeek, endDate: endOfWeek };
      setOrderDate(dateobj);
    } else if (value === 'CurrentMonth') {
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1,
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0,
      );

      firstDayOfMonth.setHours(0, 0, 0, 0);
      lastDayOfMonth.setHours(23, 59, 59, 999);

      const dateobj = { startDate: firstDayOfMonth, endDate: lastDayOfMonth };
      setOrderDate(dateobj);
    } else if (value === 'PreviousMonth') {
      const today = new Date();
      const firstDayOfCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1,
      );
      const firstDayOfPreviousMonth = new Date(firstDayOfCurrentMonth);
      firstDayOfPreviousMonth.setMonth(firstDayOfPreviousMonth.getMonth() - 1);

      const lastDayOfPreviousMonth = new Date(firstDayOfCurrentMonth);
      lastDayOfPreviousMonth.setDate(0);

      firstDayOfPreviousMonth.setHours(0, 0, 0, 0);
      lastDayOfPreviousMonth.setHours(23, 59, 59, 999);

      const dateobj = {
        startDate: firstDayOfPreviousMonth,
        endDate: lastDayOfPreviousMonth,
      };
      setOrderDate(dateobj);
    } else if (value === 'LastThreeMonth') {
      const today = new Date();
      const firstDateThreeMonthsAgo = new Date(
        today.getFullYear(),
        today.getMonth() - 2,
        1,
      );
      const lastDateCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0,
      );

      firstDateThreeMonthsAgo.setHours(0, 0, 0, 0);
      lastDateCurrentMonth.setHours(23, 59, 59, 999);

      const dateobj = {
        startDate: firstDateThreeMonthsAgo,
        endDate: lastDateCurrentMonth,
      };
      setOrderDate(dateobj);
    } else if (value === 'Last6Month') {
      const today = new Date();
      const firstDateSixMonthsAgo = new Date(
        today.getFullYear(),
        today.getMonth() - 5,
        1,
      );
      const lastDateCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0,
      );

      firstDateSixMonthsAgo.setHours(0, 0, 0, 0);
      lastDateCurrentMonth.setHours(23, 59, 59, 999);

      const dateobj = {
        startDate: firstDateSixMonthsAgo,
        endDate: lastDateCurrentMonth,
      };
      setOrderDate(dateobj);
    } else if (value === 'all') {
      const dateobj = {
        startDate: new Date('2000-01-01T00:00:00'),
        endDate: new Date(),
      };
      setOrderDate(dateobj);
    } else {
      const dateobj = {
        startDate: new Date('2000-01-01T00:00:00'),
        endDate: new Date(),
      };
      setOrderDate(dateobj);
    }
  };
  return (
    <div className="history-section">
      <div className="bottom-table-bstorm">
        <div className="positions-button history-filters">
          <div className="hf-group hf-search">
            <div className="input-text">
              <DebounceInput
                minLength={2}
                debounceTimeout={1000}
                type="text"
                value={search}
                onChange={handleSearchChange}
                placeholder={t('tables.searchSymbol')}
              />
              <div className="input-svg" id="searchSvgColor">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </div>
            </div>
          </div>

          <div className="hf-group hf-type">
            <span className="hf-label">{t('filters.positions')}</span>
            <div className="hf-pills" role="group" aria-label={t('ea.positionType')}>
              <button
                type="button"
                className={botFilter === 'all' ? 'active' : ''}
                onClick={() => setBotFilter('all')}
              >
                {t('common.all')}
              </button>
              <button
                type="button"
                className={botFilter === 'isEa' ? 'active' : ''}
                onClick={() => setBotFilter('isEa')}
              >
                {t('filters.ea')}
              </button>
              <button
                type="button"
                className={botFilter === 'normal' ? 'active' : ''}
                onClick={() => setBotFilter('normal')}
              >
                {t('filters.normal')}
              </button>
            </div>
          </div>

          <div className="hf-group hf-time">
            <div className="hf-preset">
              <span className="hf-label">{t('filters.period')}</span>
              <Select
                options={periodOptions}
                value={selectedOption}
                onChange={changehandlefunction}
                styles={customStyle}
                isSearchable={false}
                classNamePrefix="history-period"
                menuPortalTarget={document.body}
              />
            </div>
            <div className={`hf-custom ${isCustomRangeSelected ? '' : 'hf-hidden'}`}>
              <div className="date-time">
                <button
                  type="button"
                  className={`custom-date-button${showDatePicker && activeDateField === 'start' ? ' is-active' : ''}`}
                  title={formatFilterDateOrPlaceholder(datePickar.startDate)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveDateField('start');
                    setPickerAnchorRect(anchorRectFromEvent(e));
                    setShowDatePicker(true);
                  }}
                >
                  {formatFilterDateOrPlaceholder(datePickar.startDate)}
                </button>
                <span>–</span>
                <button
                  type="button"
                  className={`custom-date-button${showDatePicker && activeDateField === 'end' ? ' is-active' : ''}`}
                  title={formatFilterDateOrPlaceholder(datePickar.endDate)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveDateField('end');
                    setPickerAnchorRect(anchorRectFromEvent(e));
                    setShowDatePicker(true);
                  }}
                >
                  {formatFilterDateOrPlaceholder(datePickar.endDate)}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isEdit && (
          <>
            <div className="position-info-backdrop"></div>
            <PlatformModalLayer className="wm-parent" onDismiss={() => setIsEdit(false)} aria-label={t('accountManager.positionInfo')}>
              <div
                className="window-module"
                style={{ position: 'fixed', top: '25%', zIndex: 999 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="wm-header">
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <h2 className="wmTitleDynamic">
                      {t('accountManager.positionInfo')}<span className="popup-reference">PID{selectedPosition?.position_id
                          ? selectedPosition.position_id.toString().padStart(8, '0')
                          : '---'}</span>
                    </h2>
                    {selectedPosition?.is_bot_trade !== 1 && (
                      <button type="button" aria-label={t('ea.positionDetails')}
                    onClick={handlePositionModal}
                    title={t('ea.positionDetails')}
                        style={{ 
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                      padding: "6px",
                          backgroundColor: "var(--surface-bg, #1a1f36)",
                          borderRadius: "5px"
                        }}
                      >
                        <FaArrowUpRightFromSquare size={15} color="var(--content-primary, #e8eaf0)"/>
                      </button>
                    )}
                  </div>
                  <PopupCloseButton className="position-window-close" onClick={() => {
                      setIsEdit(false);
                    }} />
                </div>
                <div className="wm-content">
                  {/* First row: Position ID, Created Date Time, Symbol Name, Direction (4 fields) */}
                  <div className="input-content-wm">
                    <div className="row row-4">
                      <div className="wm-read-p-in">
                        <p>{t('tables.positionId')}</p>
                        <input
                          type="text"
                          readOnly
                          value={`PID${selectedPosition?.position_id ? selectedPosition.position_id.toString().padStart(8, '0') : '---'}`}
                        />
                      </div>
                      <div className="wm-read-p-in">
                        <p>{t('tables.createdDateTime')}</p>
                        <input
                          type="text"
                          readOnly
                          value={`${new Date(
                            selectedPosition.created_at,
                          ).toLocaleDateString('en-GB')}, ${new Date(
                            selectedPosition.created_at,
                          ).toLocaleTimeString('en-GB', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false,
                          })}`}
                        />
                      </div>
                      <div className="wm-read-p-in">
                        <p>{t('tables.symbolName')}</p>
                        <input
                          type="text"
                          readOnly
                          value={selectedPosition.symbol}
                        />
                      </div>
                      <div className="wm-read-p-in">
                        <p>{t('tables.direction')}</p>
                        <input
                          type="text"
                          readOnly
                          value={translateDirection(selectedPosition.direction, t)}
                        />
                      </div>
                    {/* </div>
                  </div> */}
                  {/* Second row: Entry, Margin, Quantity, PNL (4 fields) */}
                  {/* <div className="input-content-wm">
                    <div className="row row-4"> */}
                      <div className="wm-read-p-in">
                        <p>{t('tables.entry')}</p>
                        <input
                          type="text"
                          readOnly
                          value={!isNaN(parseFloat(selectedPosition.entry_price)) ? parseFloat(selectedPosition.entry_price) : "---"}
                        />
                      </div>
                      <div className="wm-read-p-in">
                        <p>{t('tables.margin')}</p>
                        <input
                          type="text"
                          readOnly
                          value={(formatFixedTrimmed(selectedPosition.margin) * userCurrencyExchangeRate, 4)}
                        />
                      </div>
                      <div className="wm-read-p-in">
                        <p>{t('tables.quantity')}</p>
                        <input
                          type="text"
                          readOnly
                          value={formatFixedTrimmed(selectedPosition.quantity, 8)}
                        />
                      </div>
                      <div className="wm-read-p-in">
                        <p>PNL</p>
                        <input
                          type="text"
                          readOnly
                          value={formatFixedTrimmed(selectedPosition.realized_pnl, 2)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </PlatformModalLayer>
            {showDealsModal && (
              <PositionEvent positionInfo={positionDealsInfo} />
            )}
          </>
        )}

        {showDatePicker && (
          <AppDatePicker
            open
            activeDateField={activeDateField}
            value={activeDateField === 'start' ? datePickar.startDate : datePickar.endDate}
            minYear={TABLE_PERIOD_MIN_YEAR}
            minDate={activeDateField === 'end' && datePickar.startDate ? datePickar.startDate : undefined}
            anchorRect={pickerAnchorRect}
            buyColor={selectedStyle?.buyColor}
            sellColor={selectedStyle?.sellColor}
            onCancel={() => setShowDatePicker(false)}
            onConfirm={(date) => {
              setDatePickar((prev) => {
                if (activeDateField === 'start') {
                  const start = parseLocalDate(date);
                  const end = parseLocalDate(prev.endDate);
                  const next = { ...prev, startDate: date };
                  if (end < start) {
                    const bumped = new Date(start);
                    bumped.setHours(23, 59, 59, 0);
                    next.endDate = bumped;
                  }
                  return next;
                }
                return { ...prev, endDate: date };
              });
              setShowDatePicker(false);
            }}
          />
        )}

        <div className="table-scroll-area" ref={positonHistoryDivRef}>
          {mobileMode && isLoading && <PanelSkeleton />}
          {mobileMode ? (
            <div className="horizontal-scroll-wrapper">
              <MobilePositionHistoryList positions={data} name ={name}/>

              {total > 1 && !enableInfiniteScroll && (
                <div className="pagination-controls">
                  <button 
                    onClick={() => setCurrentPage(1)} 
                    disabled={currentPage === 1}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M11.354 1.146a.5.5 0 0 1 0 .708L6.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                      <path d="M7.354 1.146a.5.5 0 0 1 0 .708L2.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} 
                    disabled={currentPage === 1}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M11.354 1.146a.5.5 0 0 1 0 .708L6.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => setCurrentPage(p => Math.min(p + 1, total))} 
                    disabled={currentPage === Math.ceil((total/pageSize))}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M4.646 1.146a.5.5 0 0 1 .708 0l5.5 5.5a.5.5 0 0 1 0 .708l-5.5 5.5a.5.5 0 1 1-.708-.708L9.793 7 4.646 1.854a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => setCurrentPage(Math.ceil(total/pageSize))} 
                    disabled={currentPage === Math.ceil(total/pageSize)}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M4.646 1.146a.5.5 0 0 1 .708 0L10.5 6.293 5.354 11.44a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      <path d="M8.646 1.146a.5.5 0 0 1 .708 0L14.5 6.293 9.354 11.44a.5.5 0 1 1-.708-.708L13.293 7 8.646 2.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </button>
                </div>
              )}

              {/* sentinel for infinite scroll inside the scrollable content so it moves horizontally */}
              {enableInfiniteScroll && (
                <>
                  <div ref={bottomRef} style={{ height: 30 }} />
                  {isFetchingMore && (
                    <div className="infinite-sentinel">
                      <CgSpinner color={selectedStyle.buyColor} size={20} className="spinner-rotate infinite-loader" />
                    </div>
                  )}
                  {!hasMore && !isFetchingMore && data.length > 0 && (
                    <div className="infinite-sentinel no-more-msg">
                      {t('tables.noMorePositions')}
                    </div>
                  )}
                </>
              )}
            </div>
          ) : (
            <div className="horizontal-scroll-wrapper">
              {renderRows && <DataTable
                id="position-history"
                className="history-rdt"
                columns={columns}
                progressPending={isLoading}
                progressComponent={<PanelSkeleton tableColumns={columns} />}
                data={data}
                pagination={false}
                filteringFunction={handleFilterChange}
                filtering={true}
                theme="solarized"
                customStyles={customStyles}
                conditionalRowStyles={conditionalRowStyles}
                persistTableHead
                fixedHeader={false}
                highlightOnHover={false}
                onRowClicked={(row) => {
                  if (row._endOfList) return;
                  setSelectedRowId(row.position_id);
                }}
                onRowDoubleClicked={(row) => {
                  if (row._endOfList) return;
                  handleRowClick(row);
                }}
                paginationPerPage={pageSize}
                noDataComponent={<NoRecordsMessage variant="positionHistory" />}
              />}

              {showEndRow && <div className="no-more-inline">{t('tables.noMorePositions')}</div>}
              {enableInfiniteScroll && hasMore && <div ref={bottomRef} style={{ height: 1 }} />}
              {isFetchingMore && enableInfiniteScroll && (
                <div className="infinite-sentinel">
                  <CgSpinner color={selectedStyle.buyColor} size={20} className="spinner-rotate infinite-loader" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PositionHistory;
